import dashboardSmallWidgetTemplate from './dashboardSmallWidget.html';
import './dashboardSmallWidget.scss';

export default angular
  .module('main.dashboardPanel.dashboardSmallWidget', [])

  .directive('dashboardSmallWidget', () => {
    return {
      restrict: 'E',
      template: dashboardSmallWidgetTemplate,
      scope: {
        header: '@',
        content: '=',
        trend: '=',
        trendDate: '=',
        icon: '@',
        loading: '=',
        sref: '@'
      },
      controller: ($scope, $filter) => {
        const $t = $filter('translate');
        const $date = $filter('date');
        let trendDateFormat = $t('dash.panel.trendDateFormat');

        $scope.$watch('trendDate', () => {
          if ($scope.trendDate) {
            let trendDateFormatted = $date($scope.trendDate, trendDateFormat);
            $scope.trendDateStr = $t('dash.panel.trendDate', { date: trendDateFormatted });
          } else {
            $scope.trendDateStr = undefined;
          }
        });
      }
    };
  })
  .name;
